import { SubnationalDictionary } from '@/common/types/subnational.types';
import states from './us_states.util.json';
import provinces from './ca_provinces.util.json';

const regions: SubnationalDictionary = {
  CA: provinces,
  US: states,
};

export default regions;
